// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2BD00","title":"Header_title__LEpa5","left":"Header_left__uLQyB","clinicName":"Header_clinicName__7ImZk"};